// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { BoxField, SwitchButton, Text, View } from "@components";

import type { ManagerSelfServiceSettings } from "@modules/service/reducer/manager-self-service/types";

type Props = {
  settings: ManagerSelfServiceSettings,
  onUpdateSettings: (settings: ManagerSelfServiceSettings) => void,
  onAdd: () => void,
  hasActiveManualReferrals: boolean,
  ...PropsFromLocalize,
};

export function ManagerSelfService({
  settings,
  t,
  onUpdateSettings,
  hasActiveManualReferrals,
}: Props) {
  const updateEnabled = (settingsName: string) => (value: boolean) => {
    onUpdateSettings({ ...settings, [settingsName]: value });
  };

  return (
    <View gap={6}>
      <View direction="row" justifyContent="space-between">
        <Text type="h6">{t("MANAGER_SELF_SERVICE")}</Text>
      </View>

      <BoxField title={t("ADD_EDIT_ABSENCES")} description={t("ADD_EDIT_ABSENCES_DESCRIPTION")}>
        <SwitchButton
          active={settings.addAndEditAbsences}
          onChange={updateEnabled("addAndEditAbsences")}
        />
      </BoxField>

      <BoxField title={t("CANCEL_ABSENCES")} description={t("CANCEL_ABSENCES_DESCRIPTION")}>
        <SwitchButton active={settings.cancelAbsences} onChange={updateEnabled("cancelAbsences")} />
      </BoxField>

      <BoxField title={t("NOTIFICATION_ADMIN")} description={t("NOTIFICATION_ADMIN_DESCRIPTION")}>
        <SwitchButton
          active={settings.notificationContactsAdmin}
          onChange={updateEnabled("notificationContactsAdmin")}
        />
      </BoxField>

      {hasActiveManualReferrals && (
        <>
          <BoxField
            title={t("NAVIGATOR_FULL_ACCESS_MANUAL_REFERRALS")}
            description={t("NAVIGATOR_FULL_ACCESS_MANUAL_REFERRALS_DESCRIPTION")}
          >
            <SwitchButton
              active={settings.navigatorFullAccessManualReferrals}
              onChange={updateEnabled("navigatorFullAccessManualReferrals")}
            />
          </BoxField>
          <BoxField
            title={t("NAVIGATOR_MANAGER_MANUAL_REFERRALS")}
            description={t("NAVIGATOR_MANAGER_MANUAL_REFERRALS_DESCRIPTION")}
          >
            <SwitchButton
              active={settings.navigatorManagerManualReferrals}
              onChange={updateEnabled("navigatorManagerManualReferrals")}
            />
          </BoxField>
        </>
      )}
    </View>
  );
}

export default compose(localize())(ManagerSelfService);
